import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Heading from '../../components/Heading'
import IconButton from '../../components/IconButton'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Button from '../../components/Button'
import { api, ApiRoutes } from '../../services/ApiService'
import Loader from '../../components/Loader'
import Checkbox from '../../components/Checkbox'
import {useAdmin} from "../../contexts/AdminContext";

const UpdateSettings: React.FC = () => {
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()
    const { getNotifications } = useAdmin()
    const [count, setCount] = useState<{
        individualizations: number
        spots: number
        inputs: number
    }>({
        individualizations: 0,
        spots: 0,
        inputs: 0,
    })
    const [updating, setUpdating] = useState<boolean>(false)
    const [confirmed, setConfirmed] = useState<boolean>(false)

    useEffect(() => {
        api.get(ApiRoutes.UPDATE_COUNT).then((response) => {
            setCount(response.data.data)
        })
    }, [])

    const migrate = useCallback(() => {
        setUpdating(true)
        api.get(ApiRoutes.UPDATE_MIGRATE).then((res) => {
            setUpdating(false)
            setCount(res.data.data)
            getNotifications()
        })
    }, [])

    return (
        <>
            <Heading level={3} classes={'zr-my-4'}>
                {t('update.heading')}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => navigate('/settings')}
            >
                {t('common.backToOverview')}
            </IconButton>
            <Heading level={4}>{t('update.description')}</Heading>
            <Checkbox
                property={'confirm'}
                value={confirmed}
                label={t('update.confirm')}
                onChange={(_, v) => setConfirmed(v)}
            />
            <Heading level={4}>{t('update.count')}</Heading>
            <ul className={'zr-mt-0 zr-mb-4'}>
                <li>
                    {t('update.individualizations')}: {count.individualizations}
                </li>
                <li>
                    {t('update.spots')}: {count.spots}
                </li>
                <li>
                    {t('update.inputs')}: {count.inputs}
                </li>
            </ul>
            <div className={'zr-d-flex zr-gap-4 zr-items-center'}>
                <Button
                    disabled={
                        !confirmed ||
                        (count.individualizations === 0 &&
                            count.spots === 0 &&
                            count.inputs === 0) ||
                        updating
                    }
                    hierarchy={'primary'}
                    text={t('update.action')}
                    fn={() => migrate()}
                />
                <Loader isLoading={updating} />
            </div>
        </>
    )
}

export default UpdateSettings
